import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function MagazineHeaderNavigationLinks({ links }) {
  return (
    <nav className="PrismicMagazineHeaderNavigationLinks nh5 flex">
      {links.map(({ href, isActive, title }) => (
        <a
          className={classnames(
            'PrismicMagazineHeaderNavigationLinks__link pt4 bt bw1 mh5 transition',
            {
              'b--transparent fw-medium': !isActive,
              'b--black b': isActive
            }
          )}
          href={href}
          key={href}
        >
          {title}
        </a>
      ))}
    </nav>
  );
}

MagazineHeaderNavigationLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      isActive: PropTypes.bool,
      title: PropTypes.string
    })
  ).isRequired
};
